import { LngLat } from "mapbox-gl";
import { computed } from "mobx";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMap } from "react-map-gl";
import { useMapStore, usePropertyStore } from "..";
import IProperty from "../interfaces/IProperty";

export default function useProperty(coordinate: LngLat | undefined): IPropertyInfo {
    const map = useMap().map;
    const mapStore = useMapStore();
    const propertyStore = usePropertyStore();
    const [isFetchCalled, setIsFetchCalled] = useState(false);
    const property = useMemo(() => computed(() => propertyStore.getProperty(coordinate)), [coordinate]).get();
    const isLoading = useMemo(() => computed(() => propertyStore.getIsLoading(coordinate)), [coordinate]).get();
    const isError = useMemo(() => computed(() => propertyStore.getIsError(coordinate)), [coordinate]).get();

    useEffect(() => setIsFetchCalled(false), [property]);

    useEffect(() => {
        if (!map || !isFetchCalled || !mapStore.isStyleLoaded || !coordinate)
            return;

        setIsFetchCalled(false);
        propertyStore.fetchProperty(coordinate, map);
    }, [map, mapStore.isStyleLoaded, isFetchCalled, coordinate, propertyStore]);

    const fetchProperty = useCallback(() => setIsFetchCalled(true), []);

    return useMemo(() => ({
        property,
        isLoading: isLoading,
        isError: isError,
        fetchProperty,
    }), [property, isLoading, isError, fetchProperty]);
}

export interface IPropertyInfo {
    property: IProperty | undefined;
    isLoading: boolean;
    isError: boolean;
    fetchProperty: () => void;
}
